import Parse from 'html-react-parser';

function BMP20170(props) {
    let svgCode =
    `<svg width="160" height="30" viewBox="0 0 160 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .styledText text {
        ${props.styledText}
    }
    ${props.fontFace}
    </style>     
        <g class="styledText" fill="${props.fontColour}" font-family="${props.fontName}" font-size="26" font-weight="${props.fontExtras.weight}" >
        <text><tspan x="0" y="21.0449">1</tspan></text>
        <text><tspan x="20" y="21.0449">2</tspan></text>
        <text><tspan x="40" y="21.0449">3</tspan></text>
        <text><tspan x="60" y="21.0449">4</tspan></text>
        <text><tspan x="80" y="21.0449">5</tspan></text>
        <text><tspan x="100" y="21.0449">6</tspan></text>
        <text><tspan x="120" y="21.0449">7</tspan></text>
        <text><tspan x="140" y="21.0449">8</tspan></text>
        </g>
    </svg>`

    props.svgReturn(37, svgCode, "bmp00170", 160, 30);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20170;